import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";
import { t } from "@/i18n-js/instance";

export const EoYRecap2025Page = () => {
  const { width, height } = useWindowSize();

  return (
    <main className="relative min-h-screen bg-gradient-to-br from-purple-950 via-purple-900 to-black">
      <ReactConfetti
        width={width}
        height={height}
        style={{
          zIndex: 999999,
        }}
        recycle={false}
        tweenDuration={6000}
        numberOfPieces={300}
        gravity={0.15}
        wind={0.05}
        colors={[
          "#a855f7",
          "#9333ea",
          "#7e22ce",
          "#6b21a8",
          "#ffffff",
          "#fbbf24",
          "#f59e0b",
        ]}
        initialVelocityY={-20}
        initialVelocityX={15}
      />
      <section className="relative flex min-h-screen items-center justify-center overflow-hidden">
        <div className="pointer-events-none absolute inset-0 flex select-none items-center justify-center">
          <div className="text-[28rem] font-black leading-none tracking-tighter text-white/10 md:text-[32rem] lg:text-[40rem]">
            {t("eoy_recap_2025.2025")}
          </div>
        </div>
      </section>
    </main>
  );
};
